// utils/eventBus.ts
type EventCallback = (...args : any[]) => void;

class EventBus {
	private events : Map<string, EventCallback[]> = new Map();

	emit(eventName : string, ...args : any[]) : void {
		const callbacks = this.events.get(eventName);
		if (callbacks) {
			callbacks.forEach(callback => callback(...args));
		}
	}

	on(eventName : string, callback : EventCallback) : () => void {
		if (!this.events.has(eventName)) {
			this.events.set(eventName, []);
		}
		this.events.get(eventName)!.push(callback);

		// 返回取消订阅函数
		return () => this.off(eventName, callback);
	}

	off(eventName : string, callback : EventCallback) : void {
		const callbacks = this.events.get(eventName);
		if (callbacks) {
			const index = callbacks.indexOf(callback);
			if (index > -1) {
				callbacks.splice(index, 1);
			}
		}
	}

	once(eventName : string, callback : EventCallback) : void {
		const onceCallback = (...args : any[]) => {
			callback(...args);
			this.off(eventName, onceCallback);
		};
		this.on(eventName, onceCallback);
	}
}

export const eventBus = new EventBus();